import {
  OUTLETS_FETCH_ALL,
  OUTLETS_FETCH_ALL_SUCCESS,
  OUTLETS_FETCH_ALL_FAIL,
  OUTLETS_ADD,
  OUTLETS_ADD_SUCCESS,
  OUTLETS_ADD_FAIL,
  OUTLETS_UPDATE,
  OUTLETS_UPDATE_SUCCESS,
  OUTLETS_UPDATE_FAIL,
  OUTLETS_DELETE,
  OUTLETS_DELETE_SUCCESS,
  OUTLETS_DELETE_FAIL,
  OUTLETS_SET_FILTER
} from './constants';

export const fetchOutlets = () => ({
  type: OUTLETS_FETCH_ALL
});
export const fetchOutletsSuccess = outlets => ({
  type: OUTLETS_FETCH_ALL_SUCCESS, outlets
});
export const fetchOutletsFail = error => ({
  type: OUTLETS_FETCH_ALL_FAIL, error
});
export const addOutlet = outlet => ({
  type: OUTLETS_ADD, outlet
});
export const addOutletSucccess = outlet => ({
  type: OUTLETS_ADD_SUCCESS, outlet
});
export const addOutletFail = error => ({
  type: OUTLETS_ADD_FAIL, error
});
export const updateOutlet = (outlet) => ({
  type: OUTLETS_UPDATE, outlet
});
export const updateOutletSuccess = outlet => ({
  type: OUTLETS_UPDATE_SUCCESS, outlet
});
export const updateOutletFail = (error, outlet) => ({
  type: OUTLETS_UPDATE_FAIL, error, outlet
});
export const deleteOutlet = (outlet) => ({
  type: OUTLETS_DELETE, outlet
});
export const deleteOutletSuccess = () => ({
  type: OUTLETS_DELETE_SUCCESS
});
export const deleteOutletFail = (error, outlet) => ({
  type: OUTLETS_DELETE_FAIL, error, outlet
});
export const setOutletFilter = catFilter => ({
  type: OUTLETS_SET_FILTER, catFilter
});
